<template>
  <a-collapse v-model:activeKey="activeKey" class="collapse" accordion>
    <a-collapse-panel key="1" :header="`Monitoreo de usuarios (${ data?.total_agents })`">
      <dashboard-agents :agents="data.agents" />
    </a-collapse-panel>
    <a-collapse-panel key="2" :header="`Llamadas en cola (${(data?.queues.queued?.length || 0) + (data?.queues.other?.length || 0)})`">
      <template #extra>
        <a-tooltip>
          <template #title>Llamadas que están esperando ser atendidas por un usuario.</template>

          <InfoCircleOutlined />
        </a-tooltip>
      </template>

      <a-table
        row-key="id"
        size="middle"
        :columns="callsInQueueColumns"
        :data-source="[...(data.queues.queued || []), ...(data.queues.other || [])]"
        :scroll="{ y: 300 }"
        :pagination="false"
      >
        <template #queueTime="{ record }">
          <QueueTimeCell :record="record" />
        </template>
        <template #phone="{ record, text }">
          <span>{{ "+" + text }}</span>
        </template>
      </a-table>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { ref } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { callsInQueueColumns, callsStateColumns } from "@/app/strategies/utils/constants";

import QueueTimeCell from "./cells/QueueTimeCell.vue";
import DashboardAgents from "@/app/strategies/components/tables/DashboardAgents.vue";

export default {
  components: {
    QueueTimeCell,
    InfoCircleOutlined,
    DashboardAgents,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const activeKey = ref(1);
    const tabStyle = { backgroundColor: "white" };

    return { callsInQueueColumns, callsStateColumns, activeKey, tabStyle };
  },
};
</script>

<style lang="sass" scoped>
.collapse
  border-color: transparent
</style>
